import { useState, useCallback } from 'react';
import { RescheduleReasonResult } from '.';

export const useRescheduleReason = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [promiseResolver, setPromiseResolver] = useState<{
    resolve: (value: RescheduleReasonResult | null) => void;
  } | null>(null);

  const openModalRescheduleReason = useCallback((): Promise<RescheduleReasonResult | null> => {
    setIsOpen(true);
    return new Promise(resolve => {
      setPromiseResolver({ resolve });
    });
  }, []);

  const handleConfirm = useCallback(
    (result: RescheduleReasonResult) => {
      setIsOpen(false);
      promiseResolver?.resolve(result);
    },
    [promiseResolver]
  );

  const handleCancel = useCallback(() => {
    setIsOpen(false);
    promiseResolver?.resolve(null);
  }, [promiseResolver]);

  return {
    isOpen,
    openModalRescheduleReason,
    handleConfirm,
    handleCancel
  };
};
